import z from 'zod';

/** A namespace containing basic custom zod validators / transformers.
 *
 * "cz" stands for "custom zod" */
namespace cz {
    export namespace string {
        export const emptyAsNull = (zodString: z.ZodString = z.string()) =>
            zodString.trim().transform(cz.transform.string.emptyAsNull).nullable();
    }

    export namespace transform {
        export namespace string {
            export const emptyAsNull = (str: string) => (str.length === 0 ? null : str);
        }
    }
}

export default cz;
